import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#CFCFCF'}`
    }
});